import generate from './generate';
import crm from './crm';

export default {
  generate,
  crm,
};
